/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Refer_DescInputs */

const en_dialog_refer_desc = /** @type {(inputs: Dialog_Refer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give 1 month get 1 month free when they subscribe.`)
};

const es_dialog_refer_desc = /** @type {(inputs: Dialog_Refer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regala 1 mes y obtén 1 mes gratis cuando se suscriban.`)
};

/**
* | output |
* | --- |
* | "Give 1 month get 1 month free when they subscribe." |
*
* @param {Dialog_Refer_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_refer_desc = /** @type {((inputs?: Dialog_Refer_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Refer_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_refer_desc(inputs)
	return en_dialog_refer_desc(inputs)
});